import * as React from "react"
import { SVGProps } from "react"
export const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 209.73 209.74"
    {...props}
  >
    <defs>
      <style>{".cls-3{fill:white}"}</style>
    </defs>
    <path
      d="M124.62 25.32 17.38 132.55a42.29 42.29 0 0 0 0 59.8l.58.57a42.27 42.27 0 0 0 59.19-.59L184.41 85.11a12.46 12.46 0 0 0 16.68-18.46l-58-58a12.46 12.46 0 0 0-18.47 16.67Z"
      style={{
        fill: "none",
        stroke: "white",
        strokeWidth: 10,
      }}
    />
    <path
      d="M149.48 102.89a6.14 6.14 0 0 0-4.33-10.48H75.79a6.14 6.14 0 0 0-4.34 1.8l-46.19 46.26a30.74 30.74 0 0 0 0 43.42 30.61 30.61 0 0 0 43.34 0l80.88-81Z"
      style={{
        fillRule: "evenodd",
        fill: "white",
      }}
    />
    <circle cx={117.92} cy={75.54} r={6.67} className="cls-3" />
    <circle cx={141.08} cy={65.73} r={10.2} className="cls-3" />
  </svg>
);